(function () {
  const STORAGE_KEY = 'theme:recently_viewed';
  const MAX_ITEMS = 12;

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // localStorage unavailable - state just won't persist
    }
  }

  window.RecentlyViewedStore = {
    get() {
      return read();
    },
    record(handle) {
      if (!handle) return;
      const handles = read().filter((item) => item !== handle);
      handles.unshift(handle);
      write(handles.slice(0, MAX_ITEMS));
    },
  };

  const productInfo = document.querySelector('product-info[data-product-handle]');
  if (productInfo) {
    window.RecentlyViewedStore.record(productInfo.dataset.productHandle);
  }

  if (!customElements.get('recently-viewed-list')) {
    customElements.define(
      'recently-viewed-list',
      class RecentlyViewedList extends HTMLElement {
        connectedCallback() {
          this.render();
        }

        async render() {
          const grid = this.querySelector('[data-recently-viewed-grid]');
          if (!grid) return;

          const exclude = this.dataset.exclude;
          const limit = parseInt(this.dataset.limit, 10) || 8;
          const columns = parseInt(this.dataset.columnsDesktop, 10) || 4;

          let handles = window.RecentlyViewedStore.get()
            .filter((handle) => handle !== exclude)
            .slice(0, limit);

          // Drop down to a full last row instead of leaving one item
          // dangling alone below a complete row (e.g. 5 items in a 4-col
          // grid). Only applies once there's at least one full row already -
          // a single partial row on its own (fewer items than one row) is
          // normal and left as-is.
          const fullRowCount = Math.floor(handles.length / columns) * columns;
          if (fullRowCount > 0) {
            handles = handles.slice(0, fullRowCount);
          }

          if (handles.length === 0) {
            this.hidden = true;
            return;
          }

          const cardsHtml = await Promise.all(
            handles.map((handle) =>
              fetch(`/products/${handle}?section_id=product-card-ajax`)
                .then((response) => (response.ok ? response.text() : ''))
                .catch(() => '')
            )
          );

          const html = cardsHtml
            .filter(Boolean)
            .map((cardHtml) => `<li class="grid__item">${cardHtml}</li>`)
            .join('');

          if (!html) {
            this.hidden = true;
            return;
          }

          grid.innerHTML = html;
        }
      }
    );
  }
})();
